import axios from "axios";
import { api } from "common/api/api";

const getManuals = async () => {
  try {
    const path = "/manuals";
    const res = await api.get(path);
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// レコード作成 + 書き込み用 SAS URL の発行。{ Id, UploadUrl } を返す
const createManual = async payload => {
  try {
    const path = "/manuals";
    const res = await api.post(path, payload);
    if (res.status !== 200 && res.status !== 201) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// 書き込み用 SAS URL へブラウザから直接アップロードする。
// SAS が認可情報なので共有 api インスタンス（Authorization ヘッダー付き）は使わない
const uploadManualToBlob = async (uploadUrl, file) => {
  try {
    const res = await axios.put(uploadUrl, file, {
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": "text/html; charset=utf-8"
      }
    });
    if (res.status !== 201) {
      throw new Error(res);
    }
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};

// アップロード完了/失敗の通知（uploadStatus: "UPLOADED" | "FAILED"）
const updateManualUploadStatus = async (manualId, uploadStatus) => {
  try {
    const path = `/manuals/${manualId}/upload-status`;
    const res = await api.patch(path, { UploadStatus: uploadStatus });
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

// タイトル・メモの変更（payload: { Title, Memo }）
const updateManualDetails = async (manualId, payload) => {
  try {
    const path = `/manuals/${manualId}`;
    const res = await api.patch(path, payload);
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const updateManualPublished = async (manualId, published) => {
  try {
    const path = `/manuals/${manualId}`;
    const res = await api.patch(path, { Published: published });
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const deleteManual = async manualId => {
  try {
    const path = `/manuals/${manualId}`;
    const res = await api.delete(path);
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

const getManualHtml = async manualId => {
  try {
    const path = `/manuals/${manualId}/html`;
    const res = await api.get(path, { responseType: "text" });
    if (res.status !== 200) {
      throw new Error(res);
    }
    return res.data;
  } catch (err) {
    console.error(err);
    return null;
  }
};

export {
  getManuals,
  createManual,
  uploadManualToBlob,
  updateManualUploadStatus,
  updateManualDetails,
  updateManualPublished,
  deleteManual,
  getManualHtml
};
